// extracted by mini-css-extract-plugin
export default {"litecoinLtcIcon":"LitecoinLTCIcon_litecoinLtcIcon__pOT53"};